import React from "react";
import { dialog, InputString } from "../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { exportCSVUseCase } from "../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../nq-component";
import withRouter from "../../withRouter";
import NavBar from "../../components/navbar";
import InputFactory from "../../components/InputFactory";
import excludeFields from "././components/./ExcludeField";
import DialogCreate from "./components/DialogCreate";
import DialogDelete from "./components/DialogDelete";
import DialogReset from "./components/DialogReset";
import Table from "../../components/Table";
import CalendarListPagePresenter from "./CalendarListPagePresenter";
import BaseListPage from "../../base/BaseListPage";
import OnlineDetails from "./components/OnlineDetails";

class CalendarListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CalendarListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      locations: [],
      loading: false,
      total: 0,
      count: 0,
      showDetails: false,
      empDetails: {},
      password: {},
    };
  }

  getCollectionName() {
    return "users";
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  handleSubmit = () => {
    this.presenter.handleSubmit(this.state.formData);
  };

  clickData(object, index) {
    this.setState({ showDetails: true, empDetails: object });
  }

  hideFilter() {
    this.setState({ showDetails: false });
  }

  onClickView() {
    const { empDetails } = this.state;
    if (empDetails && empDetails.id) {
      this.presenter.onClickView(empDetails);
    } else {
      console.error("No valid employee details to view");
    }
  }

  handleDelete() {
    const { empDetails } = this.state;
    this.presenter.onClickDelete(empDetails);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }

  onChangeLocation(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeLocation(value, schema);
  }

  onChangeUsername(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeUsername(value, schema);
  }

  onChangeReference(value, field) {
    const schema = this.getSchema(this.getCollectionName());
    this.presenter.onChangeReference(value, schema);
  }

  onClickAdd(object) {
    const schema = this.getSchemas();

    dialog.fire({
      html: (
        <DialogCreate
          schema={schema}
          objects={object}
          onChangeData={this.onChangeObject.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onClickDelete() {
    const { empDetails } = this.state;
    dialog.fire({
      html: (
        <>
          <DialogDelete
            empDetails={empDetails}
            clickDelete={this.handleDelete.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  onclickReset() {
    dialog.fire({
      html: (
        <>
          <DialogReset
            onChangeField={this.onChange.bind(this)}
            clickSubmit={this.onSubmitPassword.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id],
      write: ["*", user.id],
    };
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      selected,
      count,
      progress,
      empDetails,
      formData,
      locations,
    } = this.state;

    console.log("locations", locations);

    const excludedFields = ["window"];

    const locationOptions = locations
      ? locations
          .map((location) => (location && location.name ? location.name : ""))
          .filter(Boolean)
      : [];
    if (!schema) return <Progress />;
    const user = this.getCurrentUser();

    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">Calendar</h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>

              <div className="d-flex ">
                {this.state.showDetails && empDetails && (
                  <div
                    className="w-50 me-2"
                    style={{
                      width: "50%",
                      position: "sticky",
                      top: 0,
                      alignSelf: "flex-start",
                      zIndex: 1,
                    }}
                  >
                    <div className="card mt-1  p-3 w-100">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          class="bi bi-arrow-left me-2"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>
                      <label className="">Coordinator Name</label>
                      {/* <Search
                        schemas={this.getSchemas()}
                        className="mt-1"
                        onSubmit={this.searchSubmit.bind(this)}
                        fields={schema.fields}
                      /> */}
                      <InputString
                        onChange={this.onChangeUsername.bind(this)}
                        placeholder="Enter Username"
                      />
                      <label className="">Area</label>
                      <InputFactory
                        type="Enum"
                        options={locationOptions || []}
                        onChange={this.onChangeLocation.bind(this)}
                        placeholder="Select Location"
                      />
                      {/* <label>Status</label>
                      <InputFactory
                        type="Enum"
                        onChange={this.onChangeLocation.bind(this)}
                        placeholder="Select Status"
                      /> */}
                    </div>
                    <OnlineDetails
                      empDetails={empDetails.employee}
                      userDetails={empDetails}
                      clickReset={this.onclickReset.bind(this)}
                      clickView={this.onClickView.bind(this)}
                      clickDelete={this.onClickDelete.bind(this)}
                    />
                  </div>
                )}
                <div className=" w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (excludedFields.includes(key)) {
                          acc.push(key);
                        }
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(CalendarListPage);
